import { requireRoute } from "@/auth/guard";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_auth/billing")({
  beforeLoad: ({ context }) => requireRoute(context, "/billing"),
});
